import { render } from "./myTree.vue?vue&type=template&id=5a8ba63c&scoped=true"
import script from "./myTree.vue?vue&type=script&lang=js"
export * from "./myTree.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5a8ba63c"

export default script